import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState(null);
  useEffect(() => { axios.get(`${API}/blog`).then((r) => setPosts(r.data)).catch(() => setPosts([])); }, []);
  return (
    <div className="mx-auto max-w-7xl px-6 py-14 lg:px-8" data-testid="blog-page">
      <span className="text-xs font-bold uppercase tracking-widest text-teal-600">Parent tips</span>
      <h1 className="mt-2 text-4xl font-bold tracking-tight sm:text-5xl">Little guides for happy teeth</h1>
      {posts === null && <p className="mt-10 text-slate-500">Loading...</p>}
      {posts?.length === 0 && <p className="mt-10 text-slate-500">New articles coming soon.</p>}
      <div className="mt-12 grid gap-8 md:grid-cols-3">
        {posts?.map((p, i) => (
          <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${i}`}
            className={`group overflow-hidden rounded-[2rem] border-2 border-slate-800/5 bg-white transition-transform hover:-translate-y-1 ${i === 0 ? "md:col-span-2" : ""}`}>
            {p.cover && <img src={p.cover} alt="" className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${i === 0 ? "h-72" : "h-48"}`} />}
            <div className="p-7">
              <span className="rounded-full bg-[#fef7e5] px-3 py-1 text-xs font-bold text-slate-700">{p.category}</span>
              <h2 className="mt-4 text-2xl font-semibold leading-tight group-hover:text-teal-700">{p.title}</h2>
              <p className="mt-2 text-sm text-slate-600">{p.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
